export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10623.39a52670.jpg";